<template lang="html">
  <div class="detailsTREZREZ">
    <div class="detailsContent">
      <div class="oneDetail" v-for="(criteria, c ) in knownVote" :key="c">
        <div class="value">
            <span class="voteValue">{{criteria.vote}}&nbsp;/&nbsp;5</span>
            <span class="voteCriteria">{{criteria.criteriaItem.name}}</span>
        </div>
        <div class="progress-bar">
          <div class="progress-bar-fill" :style="{ width: computedProgress(criteria.vote) + '%' }"></div>
        </div>
      </div>

    </div>
  </div>

</template>


<script>
export default {
  name : "VoteDetail",
  methods:{
    computedProgress(value) {
         // Make sure progress is between 0 and 100
         return Math.max(0, Math.min(100, (value / 5) * 100));
       },

  },
  computed: {
   // Filter the array passed via props
   knownVote() {
     return this.vote.criteriasVote.filter(item => item.notknown != true);
   }
 },
  props: ["vote"]
}
</script>

<style media="screen" scoped>

.detailsTREZREZ{
  position: absolute;
  background: #FFF;
  color: #000;
  bottom: 0;
  left: 20px;
  right:20px;
  z-index:99;
  transform: translateY(calc(100% + 10px));
  min-width:300px;
  padding:20px;
  box-shadow: 0px 4px 12px 2px rgba(0, 0, 0, 0.12);

}

.detailsTREZREZ .detailsContent{
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap:20px;
  font-size:14px;
  line-height: 20px;
}
.oneDetail{

}
.value{
  display:flex;
  align-items: center;
  gap:10px;
}
.voteValue{
  font-weight: 100;
  font-size:32px;
  color:#0A2071;
  line-height: 35px;
}
.voteCriteria{
  color:#0A2071;
  font-size:16px;
  font-weight: 100;
}

.progress-bar {
  margin-top:10px;
  width: 100%;
  height: 8px; /* Adjust the height to match your example */
  background-color: #d3eaff; /* Light blue background color */
  border-radius: 4px; /* Rounded corners */
  overflow: hidden;
}

.progress-bar-fill {
  height: 100%;
  background-color: #4a90e2; /* Dark blue color */
  transition: width 0.3s ease; /* Smooth transition for progress */
  border-radius: 4px; /* To match the rounded corners */
}


.voteBtton{
  display:flex;
  gap:5px;
  align-items:center;
  cursor:pointer;
}
</style>
